<template>
  <div class="article">
    <div class="article__elements">
      <Cross class="mobile-hidden" img-width="6.7rem" bottom="16.9rem" left="46.4rem" color="orange" />
      <Cross class="mobile-hidden" img-width="4.5rem" top="57.8rem" right="5.7rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="8rem" top="27.5rem" left="26rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="7.4rem" top="17.8rem" left="65rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="8rem" top="25.1rem" right="9.4rem" color="orange" />
      <Gift3 class="mobile-hidden" img-width="7.5rem" bottom="10.2rem" right="12.5rem" />
      <Gift4 class="mobile-hidden" img-width="11.3rem" bottom="9.8rem" left="50rem" />
      <Tree2 class="mobile-hidden" img-width="9rem" top="14.9rem" left="8rem" />
      <Star2 class="mobile-hidden" img-width="4.7rem" bottom="14.1rem" left="21.3rem" />
    </div>

    <div class="article__img">
      <img class="mobile-hidden" src="@/assets/img/article5.png" alt="">
      <img class="mobile-visible" src="@/assets/img/article5-mob.png" alt="">
    </div>

    <div class="article__content">
      <h2 class="article__title">
        {{ 'Новогодние чудеса' | typograf }}
      </h2>
      <h2 class="article__title">
        {{ 'Для детей и взрослых' | typograf }}
      </h2>
      <p class="article__subtitle">
        {{ 'С приближением Нового года всем хочется верить в чудеса, пусть даже небольшие.' | typograf }}
      </p>
      <p class="article__text">
        {{ 'Особенно это важно для тех, кто встречает праздники не в самых благоприятных обстоятельствах и не в кругу семьи. Волонтеры и партнеры акции #МЫВМЕСТЕ запустили акцию для людей, находящихся в социальных учреждениях и для детей, проходящих лечение в больницах. В рамках акции проходят театральные представления, волонтеры дарят подарки, украшают больницы, устанавливают елки. Подробности прошлогодней акции — в инфографике «Ленты.ру».' | typograf }}
      </p>
      <div class="article__button-box">
        <a href="https://lenta.ru/articles/2021/12/18/newyear/" target="_blank">
          <button @click="gtmSend" class="button button--orange">Читать специальный материал</button>
        </a>
      </div>

      <ArticleFooter />
    </div>
  </div>
</template>

<script>
  import './article.scss'
  import Cross from "../Elements/Cross";
  import Snowflake2 from "../Elements/Snowflake2";
  import ArticleFooter from "../ArticleFooter/ArticleFooter";
  import Gift3 from "../Elements/Gift3";
  import Tree2 from "../Elements/Tree2";
  import Gift4 from "../Elements/Gift4";
  import Star2 from "../Elements/Star2";
  export default {
    name: "Article5",
    components: {Star2, Gift4, Tree2, Gift3, ArticleFooter, Snowflake2, Cross},
    methods: {
      gtmSend() {
        window.gtag('event', 'click', {
          'event_category': 'ch5_link_lenta_ru',
          'event_label': 'chapter_5'
        });
        window.ym(86974684, 'reachGoal', 'ch5_link_lenta_ru/click/chapter_5');
      }
    }
  }
</script>

<style scoped>

</style>
